import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import draggable from "vuedraggable";
import { getList } from "@/api/setting/dictionary";
export default {
  name: "params",
  components: {
    draggable: draggable
  },
  props: {
    type: {
      default: function _default() {
        return 'create';
      }
    },
    isInCorrespondence: {
      default: function _default() {
        return false;
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    },
    data: {
      default: function _default() {
        return {};
      }
    },
    confirmId: {
      default: function _default() {
        return undefined;
      }
    },
    id: {
      default: function _default() {
        return undefined;
      }
    },
    updateParam: {
      default: function _default() {
        return function () {};
      }
    },
    getParamDetail: {
      default: function _default() {
        return function () {};
      }
    },
    getSubjectOptions: {
      default: function _default() {
        return function () {};
      }
    },
    createParam: {
      default: function _default() {
        return undefined;
      }
    }
  },
  computed: {
    isInEdit: function isInEdit() {
      return this.isInCorrespondence && this.type === 'edit' && this.data.c21Id;
    }
  },
  data: function data() {
    var validaTableData = function validaTableData(rule, value, callback) {
      // if (value === '' || value === undefined) {
      //   callback(new Error('请输入元素数据'));
      //   return;
      // }
      callback();
    };
    return {
      rules: {
        type: [{
          required: true,
          message: '请选择元素类型',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入元素名称',
          trigger: 'change'
        }],
        account: [{
          required: true,
          message: '请选择报表科目',
          trigger: 'change'
        }],
        data: [{
          required: true,
          message: '请输入数据',
          trigger: 'change',
          validator: validaTableData
        }],
        perior: [{
          required: true,
          message: '请选择截止日期',
          trigger: 'change'
        }]
      },
      form: {
        type: undefined,
        name: undefined,
        c21Account: undefined,
        c21Amount: undefined,
        account: undefined,
        amount: undefined,
        perior: undefined,
        data: undefined
      },
      headers: [],
      options: [],
      tableDatas: [],
      etag: undefined,
      loading: false
    };
  },
  methods: {
    removeTableItem: function removeTableItem(index) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$confirm('确定删除?');
            case 1:
              _this.tableDatas.splice(index, 1);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    createTableItem: function createTableItem() {
      var data = this.headers.map(function () {
        return {
          val: ""
        };
      });
      this.tableDatas.push(data);
    },
    addHeader: function addHeader() {
      this.headers.push({
        name: '',
        width: undefined
      });
      this.updateDatas();
    },
    remove: function remove(index) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$$confirm('确定删除?');
            case 1:
              _this2.headers.splice(index, 1);
              _this2.updateDatas();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    submit: function submit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var options, widths, tableDatas, params, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$checkForm();
            case 1:
              if (!(_this3.isInCorrespondence && _this3.confirmId)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return _this3.$$confirm('确定修改?');
            case 2:
              options = JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, _this3.form), {}, {
                header: '',
                params: ''
              })));
              if (options.type === '表格' || options.type === '导入') {
                options.header = _this3.headers.map(function (item) {
                  return item.name;
                });
                options.header = options.header.join('|');
                widths = _this3.headers.map(function (item) {
                  return item.width;
                });
                options.params = "".concat(_this3.headers.length, ":").concat(widths.join('/'));
                tableDatas = _this3.tableDatas.map(function (item) {
                  return item.val;
                });
                options.data = tableDatas.join('|');
              }
              _this3.loading = true;
              if (!(_this3.isInCorrespondence && _this3.confirmId)) {
                _context3.n = 9;
                break;
              }
              _context3.p = 3;
              if (!_this3.isInEdit) {
                _context3.n = 5;
                break;
              }
              _context3.n = 4;
              return _this3.updateParam(_this3.data.c21Id, options);
            case 4:
              _context3.n = 6;
              break;
            case 5:
              params = JSON.parse(JSON.stringify(options));
              delete params.c21Id;
              delete params.c21C02Id;
              _context3.n = 6;
              return _this3.createParam(params);
            case 6:
              _this3.loading = false;
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t = _context3.v;
              _this3.loading = false;
            case 8:
              _this3.loading = false;
              _this3.$emit('submit');
              _context3.n = 10;
              break;
            case 9:
              _this3.$emit('submit', options);
            case 10:
              return _context3.a(2);
          }
        }, _callee3, null, [[3, 7]]);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    typeChange: function typeChange(val) {
      // let item = this.options.find((child) => {
      //   return child.c12AccountName === val;
      // });
      // if (item) {
      //   this.form.amount = item.c12AccountSum;
      //   this.form.perior = item.c12Time;
      // }
    },
    updateDatas: function updateDatas() {
      var _this4 = this;
      // this.tableDatas = this.tableDatas.map((list) => {
      //   return this.headers.map((_,index)=>{
      //     return {
      //       val:list[index] ? list[index].val : undefined
      //     }
      //   })
      // })
      this.tableDatas = this.headers.map(function (_, index) {
        return {
          val: _this4.tableDatas[index] ? _this4.tableDatas[index].val : undefined
        };
      });
    },
    transformData: function transformData() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.form = _objectSpread(_objectSpread(_objectSpread({}, this.form), this.data), options);
      var ceParameter = this.data.params;
      var widths = ceParameter.split(':');
      widths.shift();
      widths = widths.join('').split('/');
      var ceHeader = this.data.header.split('|');
      this.headers = ceHeader.map(function (item, index) {
        return {
          name: item,
          width: widths[index] ? widths[index] : undefined
        };
      });
      if (this.data.data) {
        var tableDatas = this.data.data;
        if (tableDatas) {
          tableDatas = tableDatas.split('|');
          this.tableDatas = tableDatas.map(function (item) {
            return {
              val: item
            };
          });
        }
      } else {
        this.updateDatas();
      }
    },
    getOptions: function getOptions() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this5.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: 'c12AccountName'
              }));
            case 1:
              _yield$_this5$$awaitT = _context4.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1].data;
              if (!err) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              if (Array.isArray(data.datas)) {
                _this5.options = data.datas;
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var options;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _this6.getOptions();
            if (!(_this6.type === 'edit')) {
              _context5.n = 3;
              break;
            }
            options = {};
            _this6.loading = true;
            if (!_this6.isInEdit) {
              _context5.n = 2;
              break;
            }
            _context5.n = 1;
            return _this6.getParamDetail(_this6.data.c21Id);
          case 1:
            options = _context5.v;
          case 2:
            _this6.loading = false;
            _this6.transformData(options);
            _context5.n = 4;
            break;
          case 3:
            if (_this6.data) {
              _this6.transformData({
                account: undefined,
                amount: undefined,
                perior: undefined
              });
            }
          case 4:
            if (_this6.taskId) {
              _this6.loading = true;
              _this6.loading = false;
            }
          case 5:
            return _context5.a(2);
        }
      }, _callee5);
    }))();
  }
};